/** Esqueleto da lista enquanto a planilha carrega: mesma geometria do conteúdo final. */
import React from "react";

const LINHAS = 8;

export default function EsqueletoDaLista() {
  return (
    <div className="clg" aria-busy="true" aria-label="Carregando clientes">
      <div className="cl-crumb"><span className="cl-sk" style={{ width: 180, height: 12 }} /></div>
      <div className="cl-head">
        <div>
          <span className="cl-sk" style={{ width: 160, height: 32 }} />
          <span className="cl-sk" style={{ width: 320, height: 14, marginTop: 12 }} />
        </div>
      </div>
      <div className="cl-lgrid">
        <div className="cl-kpis cl-hscroll">
          {Array.from({ length: 5 }, (_, i) => (
            <div key={i} className="cl-kpi" style={{ height: 104 }}>
              <span className="cl-sk" style={{ width: "50%", height: 10 }} />
              <span className="cl-sk" style={{ width: 56, height: 24, marginTop: 14 }} />
              <span className="cl-sk" style={{ width: "70%", height: 10, marginTop: 14 }} />
            </div>
          ))}
        </div>
        <div className="cl-ins">
          {Array.from({ length: 3 }, (_, i) => (
            <div key={i} className={`cl-card${i === 0 ? " cl-jev" : ""}`} style={{ minHeight: 260 }}>
              <span className="cl-sk" style={{ width: "40%", height: 12 }} />
              <span className="cl-sk" style={{ width: "100%", height: 12, marginTop: 18 }} />
              <span className="cl-sk" style={{ width: "86%", height: 12, marginTop: 10 }} />
              <span className="cl-sk" style={{ width: "64%", height: 12, marginTop: 10 }} />
            </div>
          ))}
        </div>
        <div className="cl-bar">
          <span className="cl-sk" style={{ width: 420, maxWidth: "100%", height: 44, borderRadius: 12 }} />
        </div>
        <div className="cl-tbl">
          {Array.from({ length: LINHAS }, (_, i) => (
            <div key={i} className="cl-row" style={{ cursor: "default" }}>
              <span className="c-h cl-sk" style={{ width: 44, height: 44, borderRadius: "50%" }} />
              <span className="c-c">
                <span className="cl-sk" style={{ width: "60%", height: 13 }} />
                <span className="cl-sk" style={{ width: "40%", height: 10, marginTop: 8 }} />
              </span>
              <span className="c-a"><span className="cl-sk" style={{ width: "100%", height: 6 }} /></span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
